module.exports = __webpack_public_path__ + "assets/slider.dca17dd6.svg";